// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jBoqj","colBig":"styles_colBig__3FSjt","colSmall":"styles_colSmall__V_u72"};